export default __webpack_public_path__ + "static/media/al.e955cd23.svg";